// MaintenancePage.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';

const MaintenancePage = () => {
  const { t } = useTranslation();

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>{t('MAINTENANCE.TITLE')}</h1>
      <p>{t('MAINTENANCE.MESSAGE')}</p>
    </div>
  );
};

export default MaintenancePage;